<div class="box-theme">
  <div class="head">
    <div class="header">
      <div class="ico">
        <img src="./assets/img/icon-9.png" alt="Negociación de deuda para clientes residenciales">
      </div>
    </div>
    <div class="body">
      <h1>Negociación de deuda para clientes residenciales</h1>
      <p>En esta sección podrás hacer una propuesta de negociación de deuda para
        <br/> tu domicilio.</p>
    </div>
  </div>
  <div class="body">
    <div class="counter-pasos">
      <ul class="stepper-lineas">
        <li>
          <span class="linea-current"></span>
        </li>
        <li></li>
      </ul>
      <ul class="stepper">
        <li [ngClass]="{ 'numActive':pasos[0]['P1'].CurrentNum === true }">
          <p>1</p>
        </li>
        <li [ngClass]="{ 'numActive':pasos[0]['P2'].CurrentNum === true }">
          <p>2</p>
        </li>
        <li [ngClass]="{ 'numActive':pasos[0]['P3'].CurrentNum === true }">
          <p>3</p>
        </li>
      </ul>
    </div>
    <!-- PASO NUMERO 1 -->
    <div class="paso-1" *ngIf="pasos[0]['P1'].I">
      <div class="header">
        <h2>
          Para gestionar este trámite primero debes reunir<br/> los siguientes documentos:
        </h2>
      </div>
      <div class="body">
        <ul>
          <li>
            <p class="numero">1</p>
            <p class="titulo">Copia de la cédula de identidad de quien realiza la solicitud.</p>
          </li>
        </ul>
      </div>
      <div class="footer">
        <div class="callToAcction">
          <div class="mitad">
            <input type="button" value="VOLVER" class="btn btn-volver" [routerLink]="['/home']">
          </div>
          <div class="mitad text-right">
            <div class="info-continuar text-center">
              <p>Si ya tienes los documentos,<br/>presiona continuar</p>
              <input type="button" value="CONTINUAR" class="btn btn-continuar" (click)="gotoPaso(2, null)">
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- PASO NUMERO 2 -->
    <div class="paso-2" *ngIf="pasos[0]['P2'].I">
      <div class="header">
        <h2>
          Solicitud de deuda para clientes residenciales
        </h2>
      </div>
      <div class="body">
        <form [formGroup]="formData">
          <div class="form">
            <div class="head">
              <h2>
                Identificación del solicitante
              </h2>
              <p class="txt-orange">
                (**datos obligatorios)
              </p>
            </div>
            <div class="body">
              <ul>
                <li>
                  <div class="box-campo-form">
                    <input type="text" placeholder="**Nombre y apellido" formControlName="nombre" [maxLength]="200" [ngClass]="{ 'is-invalid': submitted && f.nombre.errors }"/>
                    <div class="error">
                      <div *ngIf="submitted && f.nombre.errors">
                        <p *ngIf="f.nombre.errors.required">
                          dato obligatorio
                        </p>
                        <p *ngIf="f.nombre.errors.pattern">
                          nombre inválido
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="box-campo-form">
                    <input type="text" placeholder="**Cédula de identidad" formControlName="rut" [maxLength]="12" [ngClass]="{ 'is-invalid': submitted && f.rut.errors }" (blur)="formatearRut($event)"/>
                    <div class="error">
                      <div *ngIf="submitted && f.rut.errors">
                        <p *ngIf="f.rut.errors.required">
                          dato obligatorio
                        </p>
                        <p *ngIf="f.rut.errors.maxlength || f.rut.errors.minlength || f.rut.errors?.rutValid">
                          rut inválido
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="box-campo-form">
                    <input type="text" placeholder="Teléfono de contacto" formControlName="telefono" [maxLength]="9" [ngClass]="{ 'is-invalid': submitted && f.telefono.errors }"/>
                    <div class="error">
                      <div *ngIf="submitted && f.telefono.errors">
                        <p *ngIf="f.telefono.errors.required">
                          dato obligatorio
                        </p>
                        <p *ngIf="f.telefono.errors.maxlength || f.telefono.errors.pattern">
                          teléfono inválido
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="box-campo-form">
                    <input type="email" placeholder="**Correo electrónico" formControlName="email" [maxLength]="200" [ngClass]="{ 'is-invalid': submitted && f.email.errors }"/>
                    <div class="error">
                      <div *ngIf="submitted && f.email.errors">
                        <p *ngIf="f.email.errors.required">
                          dato obligatorio
                        </p>
                        <p *ngIf="f.email.errors.email || f.email.errors.maxlength">
                          email inválido
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="form">
            <div class="head">
              <h2>
                Datos del domicilio
              </h2>
            </div>
            <div class="body">
              <ul>
                <li>
                  <div class="box-campo-form">
                    <div class="cont-numero-cliente">
                      <input type="text" placeholder="**Número de cliente" [maxLength]="9" formControlName="nCliente" [ngClass]="{ 'is-invalid': submitted && f.nCliente.errors }"/>
                      <div class="error" *ngIf="formData.get('nCliente')?.errors?.numClienteValid || formData.get('nCliente')?.errors?.numClienteExist">
                        <p>  número de cliente inválido</p>
                    </div>
                      <div class="div-numero-cliente">
                        <a style="cursor: pointer;" (click)="mostrarNumeroCliente()">
                          <img class="info-numero-cliente" src="./assets/img/info-icon.png" alt="Información número de cliente">
                        </a>
                      </div>
                      <div class="error">
                        <div *ngIf="submitted && f.nCliente.errors">
                          <p *ngIf="f.nCliente.errors.required">
                            dato obligatorio
                          </p>
                          <p *ngIf="f.nCliente.errors.maxlength || f.nCliente.errors.pattern || f.nCliente.errors.numClienteValid">
                            número de cliente inválido
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="box-campo-form">
                    <input type="text" placeholder="**Dirección" formControlName="direccion" [maxLength]="200" [ngClass]="{ 'is-invalid': submitted && f.direccion.errors }"/>
                    <div class="error">
                      <div *ngIf="submitted && f.direccion.errors">
                        <p *ngIf="f.direccion.errors.required">
                          dato obligatorio
                        </p>
                        <p *ngIf="f.direccion.errors.pattern">
                          dirección inválida
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="box-campo-form">
                      <div class="ng-autocomplete">
                          <ng-select #region [items]="dataRegion" [selectOnTab]="true" bindValue="id_region" bindLabel="nombre_region" placeholder="**Región" formControlName="region" notFoundText="Región no encontrada" >
                          </ng-select>
                      </div>
                      <div class="error">
                          <div *ngIf="submitted && f.region.errors">
                              <p *ngIf="f.region.errors.required">
                                  dato obligatorio
                              </p>
                              <p *ngIf="f.region.errors.pattern">
                                  región inválida
                              </p>
                          </div>
                      </div>
                  </div>
              </li>
              <li>
                  <div class="box-campo-form">

                    <input type="text" placeholder="**Comuna" formControlName="comuna" [maxLength]="200" [ngClass]="{ 'is-invalid': submitted && f.comuna.errors }"/>
                    <div class="error">
                      <div *ngIf="submitted && f.comuna.errors">
                        <p *ngIf="f.comuna.errors.required">
                          dato obligatorio
                        </p>
                        <p *ngIf="f.comuna.errors.pattern">
                          comuna inválida
                        </p>
                      </div>
                    </div>
                  </div>
              </li>
              </ul>
            </div>
          </div>
          <div class="form">
            <div class="head">
              <h2>
                Detalla tu propuesta para esta solicitud
              </h2>
            </div>
            <div class="body">
              <ul>
                <li>
                  <div class="box-campo-form">
                    <textarea formControlName="propuestas" placeholder="**Detalla tu propuesta" [maxLength]="250" [ngClass]="{ 'is-invalid': submitted && f.propuestas.errors }"></textarea>
                    <div class="error">
                      <div *ngIf="submitted && f.propuestas.errors">
                        <p *ngIf="f.propuestas.errors.required">
                          dato obligatorio
                        </p>
                        <p *ngIf="f.propuestas.errors.maxlength || f.propuestas.errors.pattern">
                          propuestas con caracteres inválidos
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="form">
            <div class="head">
              <h2>
                Adjuntar los siguientes archivos:
              </h2>
              <p class="txt-orange">
                (datos obligatorios)
              </p>
            </div>
            <p class="txt-tipo">
              (Se permiten los siguientes tipos de archivos: .PNG, .JPEG, .DOC, .DOCX, .PDF)
            </p>
            <div class="body">
              <ul class="uploadFile">
                <li>
                  <div class="tipoFile">
                    <p>Cédula identidad<br/>
                      solicitante (frontal)
                      <span class="error">
                        <span *ngIf="submitted && f.fileCedulaIdentidad.errors && f.fileCedulaIdentidad.errors.required">
                          <br>archivo requerido
                        </span>
                        <span *ngIf="submitted && f.fileCedulaIdentidad.errors && f.fileCedulaIdentidad.errors.requiredFileType">
                          <br>archivo no válido
                        </span>
                      </span></p>
                  </div>
                  <div class="campo">
                    <label for="fileCedulaIdentidad" class="custom-file-input"></label>
                    <input type="file" class="custom-file-input hidden" name="fileCedulaIdentidad" id="fileCedulaIdentidad" formControlName="fileCedulaIdentidad" accept="{{mimeTypes}}" (change)="fileRutCedulaProgress($event)">
                  </div>
                  <div class="aciones">
                    <ul>
                      <li>
                        <img src="./assets/img/check-0.png" alt ="Archivo no cargado" *ngIf="!infoMessage1 && !errorInfoMessage1">
                        <img src="./assets/img/check-1.png" alt ="Archivo cargado" *ngIf="infoMessage1">
                        <img src="./assets/img/error.png" alt="Archivo cargado con error" *ngIf="errorInfoMessage1" title="{{errorInfoMessage1}}">
                      </li>
                      <li *ngIf="!isMobile">
                        <img src="./assets/img/ver-0.png" alt="Ver archivo" *ngIf="!infoMessage1">
                        <img src="./assets/img/ver-1.png" alt="Ver archivo" *ngIf="infoMessage1" (click)="lightboxFile(1)">
                      </li>
                      <li>
                        <img src="./assets/img/delete-0.png" alt="Eliminar archivo" (click)="eliminarArchivo(1, 'fileCedulaIdentidad')">
                      </li>
                    </ul>
                  </div>
                </li>
                <li>
                  <div class="tipoFile">
                    <p>Cédula identidad<br/>
                      solicitante (reverso)
                      <span class="error">
                        <span *ngIf="submitted && f.fileCedulaIdentidadReverso.errors && f.fileCedulaIdentidadReverso.errors.required">
                          <br>archivo requerido
                        </span>
                        <span *ngIf="submitted && f.fileCedulaIdentidadReverso.errors && f.fileCedulaIdentidadReverso.errors.requiredFileType">
                          <br>archivo no válido
                        </span>
                      </span></p>
                  </div>
                  <div class="campo">
                    <label for="fileCedulaIdentidadReverso" class="custom-file-input"></label>
                    <input type="file" class="custom-file-input hidden" name="fileCedulaIdentidadReverso" id="fileCedulaIdentidadReverso" formControlName="fileCedulaIdentidadReverso" accept="{{mimeTypes}}" (change)="fileRutCedulaReversoProgress($event)">
                  </div>
                  <div class="aciones">
                    <ul>
                      <li>
                        <img src="./assets/img/check-0.png" alt ="Archivo no cargado" *ngIf="!infoMessage2 && !errorInfoMessage2">
                        <img src="./assets/img/check-1.png" alt ="Archivo cargado" *ngIf="infoMessage2">
                        <img src="./assets/img/error.png" alt="Archivo cargado con error" *ngIf="errorInfoMessage2" title="{{errorInfoMessage2}}">
                      </li>
                      <li *ngIf="!isMobile">
                        <img src="./assets/img/ver-0.png" alt="Ver archivo" *ngIf="!infoMessage2">
                        <img src="./assets/img/ver-1.png" alt="Ver archivo" *ngIf="infoMessage2" (click)="lightboxFile(2)">
                      </li>
                      <li>
                        <img src="./assets/img/delete-0.png" alt="Eliminar archivo" (click)="eliminarArchivo(2, 'fileCedulaIdentidadReverso')">
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
            <div class="terminos-condiciones">
              <ul>
                <li>
                  <div class="box-campo-form">
                    <label class="container-checkbox">
                      <input type="checkbox" formControlName="terminos" name="terminos" value="terminos" required>
                      <span class="checkmark"></span>
                    </label>
                    <p>
                      <a style="cursor: pointer;" (click)="mostrarTerminos($event)">He leído y aceptado la política de privacidad.</a>
                      <span class="error">
                        <span *ngIf="submitted && f.terminos.errors && f.terminos.errors.required">
                          <br>Check requerido
                        </span>
                      </span>
                    </p>
                  </div>
                </li>
                <li>
                  <div class="box-campo-form">
                    <label class="container-checkbox">
                      <input [ngClass]="getCheckboxClass()" type="checkbox" formControlName="suscripcion" name="suscripcion" value="suscripcion" (change)="onSuscripcionChange($event)">
                      <span class="checkmark"></span>
                    </label>
                    <p>
                      <a [ngClass]="getTextClass()" style="cursor: pointer;" (click)="mostrarSuscripcion($event)">Suscripción a Boleta electrónica.</a>
                    </p>
                  </div>
              </li> 
              </ul>
            </div>
            <div class="footer">
              <div class="callToAcction">
                <input type="button" value="VOLVER" class="btn btn-volver-p2" (click)="gotoPaso(1, null)">
                <input type="button" value="GUARDAR" class="btn btn-continuar" (click)="onSubmit()">
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="paso-3" *ngIf="pasos[0]['P3'].I">
      <div class="body">
        <app-solicitud-recibida [solicitud]="respuesta.NumAviso" [codigo]="respuesta.Mensajes.item[0].CodMensaje" [mensaje]="respuesta.Mensajes.item[0].TxtMensajes" [plazo]="plazo"></app-solicitud-recibida>
      </div>
    </div>
  </div>
</div>

<div class="modal-suscripcion">
  <div class="punto-informacion">
    <ul>
      <li>
        <div class="contenido-terminos">
          <h3>Condiciones de uso.</h3>
          <p>
            Autorizo a la empresa Metrogas, RUT 96.722.460-K, para que me envíe los documentos tributarios electrónicos a través
            del correo electrónico registrado.
          </p>
          <p>
            La presente autorización estará vigente desde ahora y hasta el momento en que sea revocada por mí, en cualquier
            tiempo y sin necesidad de expresión de causa.
          </p>
          <div class="callToAcction">
            <input type="button" value="Aceptar" class="btn-cerrar-modal center" onclick="$('.basicLightbox').hide();">
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>

<div class="modal-requerido">
  <div class="punto-informacion">
    <h3>Debes completar todos los datos solicitados para continuar</h3>
    <div class="callToAcction">
      <input type="button" value="CONTINUAR" class="btn btn-continuar center" onclick="$('.basicLightbox').hide();">
    </div>
  </div>
</div>

<div class="modal-error">
  <div class="punto-informacion">
    <h3>Ha ocurrido un error, vuelva a intentarlo más tarde</h3>
    <div class="callToAcction">
      <input type="button" value="CONTINUAR" class="btn btn-continuar center" onclick="$('.basicLightbox').hide();">
    </div>
  </div>
</div>

<div class="modal-error-cliente">
  <div class="punto-informacion">
      <h3>El número de cliente no existe o es erróneo</h3>
      <div class="callToAcction">
          <input type="button" value="CONTINUAR" class="btn btn-continuar center" onclick="$('.basicLightbox').hide();">
      </div>
  </div>
</div>

<div class="modal-numero-cliente">
  <div class="punto-informacion">
    <!--<img class='img-numero-cliente' src='./assets/img/numero_cliente.png'>-->
    <img class='img-numero-cliente' src='./assets/img/conoce-numero-cliente.jpg' alt="Conoce tu número de cliente">
    <br>
    <p class="texto-numero-cliente">
      Si no tienes tu número de cliente obtenlo ingresando tu dirección en metrogas.cl
      <!--El número de cliente aparece en la parte superior de su boleta de gas.-->
    </p>
    <div class="callToAcction">
      <input type="button" value="CONTINUAR" class="btn btn-continuar center" onclick="$('.basicLightbox').hide();">
    </div>
    <br>
  </div>
</div>

<ngx-spinner>
  <p style="font-size: 20px; color: white">{{spinnerMsg}}</p>
</ngx-spinner>
